export default __webpack_public_path__ + "static/media/ModalImage21.e399e710.PNG";